export type TParametersTypes = string | number | boolean;

export function filtersToQueryParameters<
  T extends Partial<Record<keyof T, TParametersTypes>> = Record<string, TParametersTypes>,
>(filters: T | undefined): URLSearchParams {
  const params = new URLSearchParams();

  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        if (typeof filters[key] === 'boolean') {
          params.set(key, filters[key] ? '1' : '0');
        } else {
          params.set(key, filters[key].toString());
        }
      }
    });
  }

  return params;
}
